export type AuthScope = 'seller' | 'customer';
export const authScope = (): AuthScope => /^\/(admin(?:\/|$)|broadcast(?:\/|$))/.test(window.location.pathname) ? 'seller' : 'customer';
export const authStorageKey = (name: 'key' | 'authority', scope: AuthScope = authScope()) => scope === 'seller' ? `seller_${name}` : name;

// Move the old seller session once; customer callbacks never remove seller keys.
export function migrateSellerSession() {
  for (const storage of [localStorage, sessionStorage]) {
    if (storage.getItem('authority') && storage.getItem('key')) {
      if (!storage.getItem('seller_key')) storage.setItem('seller_key', storage.getItem('key')!);
      storage.setItem('seller_authority', 'ok');
      storage.removeItem('key'); storage.removeItem('authority');
    }
  }
}
export function readRefreshToken(scope: AuthScope = authScope()) {
  migrateSellerSession();
  return localStorage.getItem(authStorageKey('key', scope)) || sessionStorage.getItem(authStorageKey('key', scope));
}
export function clearStoredSession(scope: AuthScope = authScope()) {
  for (const storage of [localStorage, sessionStorage]) {
    storage.removeItem(authStorageKey('key', scope)); storage.removeItem(authStorageKey('authority', scope));
  }
}
